import Vue from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { Loading, InfiniteScroll } from 'element-ui';
import { MotionPlugin } from '@vueuse/motion';
import Print from 'vue-print-nb';

// 动效库
import AOS from 'aos';
import 'aos/dist/aos.css';

import router from './router';
import pinia from './stores';
import App from './App.vue';

import '@unocss/reset/tailwind-compat.css';
import './styles/index.css';
import '@wangeditor/editor/dist/css/style.css';

import './permission';

import '@/styles/themes/dart.scss';
import '@/styles/themes/light.scss';

// single import ElementUI Loading directives
Vue.use(InfiniteScroll);
Vue.use(Loading.directive);

// import Vue Motion
Vue.use(MotionPlugin);

// Global instruction
Vue.use(Print as any);

// import AMap
import { AMapPlugin } from './map';
Vue.use(AMapPlugin, {
  key: import.meta.env.ROSA_MAPKey,
  plugins: [
    'AMap.AutoComplete',
    'AMap.CircleEditor',
    'AMap.Geocoder',
    'AMap.Geolocation',
    'AMap.MouseTool',
    'AMap.PlaceSearch',
    'AMap.PolygonEditor',
    'AMap.ToolBar',
  ],
  securityJsCode: import.meta.env.ROSA_MAP_SECURITY_JS_CODE,
});

import NavBar from './layouts/components/NavBar/index.vue';
import SideBar from './layouts/components/SideBar/index.vue';
Vue.component('NavBar', NavBar);
Vue.component('SideBar', SideBar);

// import Dayjs
dayjs.locale('zh-cn');
Vue.prototype.$aos = AOS;

Vue.prototype.$aos.init({
  // 全局设置:
  disable: false, // 接受以下值: 'phone'（手机）, 'tablet'（平板）, 'mobile'（移动设备）, 布尔值, 表达式或函数，决定是否禁用动画
  startEvent: 'DOMContentLoaded', // 当文档触发该事件时，AOS 会初始化
  initClassName: 'aos-init', // 初始化后应用的类名
  animatedClassName: 'aos-animate', // 动画开始时应用的类名
  useClassNames: false, // 如果为 true，将使用 `data-aos` 的值作为类名添加在滚动时
  disableMutationObserver: false, // 禁用自动检测 DOM 变化（高级功能）
  debounceDelay: 50, // 在调整窗口大小时使用的防抖延迟（高级功能）
  throttleDelay: 99, // 页面滚动时使用的节流延迟（高级功能）
  // 可以通过 `data-aos-*` 属性在每个元素上单独覆盖的设置:
  offset: 120, // 从触发点的偏移量（以像素为单位）
  delay: 0, // 延迟时间（0 到 3000 毫秒之间，步长为 50ms）
  duration: 300, // 动画持续时间（0 到 3000 毫秒之间，步长为 50ms）
  easing: 'ease', // AOS 动画的默认缓动效果
  once: false, // 动画是否只在向下滚动时触发一次
  mirror: true, // 元素在滚动经过后是否会反向动画
  anchorPlacement: 'top-bottom', // 定义窗口与元素的哪个位置关系触发动画
});

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  pinia,
  setup() {
    const dictStore = useDictStore();
    Vue.prototype.$zcDict = dictStore.zcDict;
    Vue.prototype.$getLabel = storeToRefs(dictStore).getLabel.value;
    Vue.prototype.$dayjs = dayjs;
  },
  render: (h) => h(App),
});
